import { TextField } from "@mui/material";

interface TextFieldPlaceholderProps {
  size?: "small" | "medium" | undefined;
}

export const TextFieldPlaceholder = ({
  size = "small",
}: TextFieldPlaceholderProps) => {
  return (
    <TextField
      size={size}
      disabled
      sx={{ border: "none", "& fieldset": { border: "none" } }}
    />
  );
};
